export default __webpack_public_path__ + "static/aboutus1-480-cde68eb070bafc5d0b0bd6152df765c2.png";